import type { SxProps, Theme } from '@mui/material'

export const styles = {
  root: {
    width: '100%',
    minHeight: 0,
  },
} satisfies Record<string, SxProps<Theme>>
